import { render, staticRenderFns } from "./LeadApplyDetails.vue?vue&type=template&id=6fb86fd6&scoped=true&"
import script from "./LeadApplyDetails.vue?vue&type=script&lang=js&"
export * from "./LeadApplyDetails.vue?vue&type=script&lang=js&"
import style0 from "./LeadApplyDetails.vue?vue&type=style&index=0&id=6fb86fd6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb86fd6",
  null
  
)

export default component.exports